export const messages = {
  en: {
    purchaseApplyDetailManage: {
      page: {
        title: 'Inbound/Outbound Details',
        subtitle: 'Track purchase apply detail records',
        empty: 'No purchase details found'
      },
      search: {
        title: 'Search Conditions',
        applyOrderId: 'Please enter application order number',
        state: 'Please select status',
        name: 'Please enter applicant name',
        endUserName: 'Please enter end user name',
        resName: 'Please enter item name',
        warehousingWay: 'Please select purchase method',
        startTime: 'Please select creation start time',
        endTime: 'Please select creation end time',
        parentRstId: 'Please select item type',
        rstId: 'Please select secondary category',
        rssId: 'Please select item specification',
        rsId: 'Please select supplier',
        shId: 'Please select warehouse',
        hide: 'Hide',
        more: 'More'
      },
      list: {
        title: 'Inbound/Outbound Details'
      },
      table: {
        applyOrderId: 'Application Order No.',
        userName: 'Applicant',
        endUserName: 'End User',
        resOrderTypeName: 'Inbound/Outbound Type',
        rstName: 'Item Type',
        resName: 'Item Name',
        specName: 'Item Specification',
        isFixedName: 'Fixed Item',
        supplierName: 'Supplier',
        shName: 'Item Warehouse',
        warehousingWayName: 'Purchase/Outbound Method',
        quantity: 'Application Quantity',
        purchaseQuantity: 'Purchase/Outbound Quantity',
        price: 'Purchase Price',
        totalApplyPrice: 'Total Price',
        remark: 'Application Remarks',
        stateName: 'Status',
        createTime: 'Creation Time'
      }
    }
  },
  zh: {
    purchaseApplyDetailManage: {
      page: {
        title: '出入库明细',
        subtitle: '跟踪采购申请明细记录',
        empty: '暂无采购明细'
      },
      search: {
        title: '查询条件',
        applyOrderId: '请填写申请单号',
        state: '请选择状态',
        name: '请填写申请人姓名',
        endUserName: '请填写使用人姓名',
        resName: '请填写物品名称',
        warehousingWay: '请选择采购方式',
        startTime: '请选择创建开始时间',
        endTime: '请选择创建结束时间',
        parentRstId: '请选择物品类型',
        rstId: '请选择二级分类',
        rssId: '请选择物品规格',
        rsId: '请选择供应商',
        shId: '请选择仓库',
        hide: '隐藏',
        more: '更多'
      },
      list: {
        title: '出入库明细'
      },
      table: {
        applyOrderId: '申请单号',
        userName: '申请人',
        endUserName: '使用人',
        resOrderTypeName: '出入库类型',
        rstName: '物品类型',
        resName: '物品名称',
        specName: '物品规格',
        isFixedName: '固定物品',
        supplierName: '供应商',
        shName: '物品仓库',
        warehousingWayName: '采购/出库方式',
        quantity: '申请数量',
        purchaseQuantity: '采购/出库数量',
        price: '采购价格',
        totalApplyPrice: '总价',
        remark: '申请备注',
        stateName: '状态',
        createTime: '创建时间'
      }
    }
  }
}